module.exports = __webpack_public_path__ + "img/handcare_handcreamset_202312.087cb1fa.jpg";